<template>
  <div style="height: 100%;" v-if="isLoadConfig">
    <grid :showChange="true" :changeNamespace="namespace" ref="myGrid" :gridConfigUrl="gridConfigUrl">
      <template slot="topNoSelectMenus">
        <grid-menu-a
          class="btn btn-hollow"
          @menu-click="back"
          name="返回"
        >
        </grid-menu-a>
      </template>
      <template slot="headerColumns">
        <li class="mTable-cell">
          <div class="mTable-cell-wrap">
            <span class="mTable-txt">查看数据</span>
          </div>
        </li>
      </template>
      <template slot="bodyColumns" slot-scope="props">
        <li class="mTable-cell">
          <div class="mTable-cell-wrap">
            <span class="mTable-txt">
              <a @click="showDetail(props.row)" style="color: #677de0;cursor: pointer;">查看数据</a>
            </span>
          </div>
        </li>
      </template>
    </grid>
    <el-dialog :visible.sync="visible" custom-class="whaty-dialog-form"
               @close="handleDialogClose" width="40%">
      <div slot="title" class="popup-head">
        <span class="popup-tit">删除前快照</span>
      </div>
      <el-scrollbar class="whaty-scroll">
        <div>
          <div class="whaty-common-form">
            <div class="popup-body">
              <div class="popup-content popup-content-complex" style="overflow-y:auto; overflow-x:auto;">
                <div class="clearfix popup-content-in">
                  <div class="form-table" style="width: 100%;">
                    <ul>
                      <template v-for="(value, key) in detailData">
                        <li class="form-table-row">
                          <div class="form-table-wrap" style="padding-left: 190px;">
                            <div class="form-table-head" style="width: 150px;">{{ key }}</div>
                            <div class="form-table-body">{{ value }}</div>
                          </div>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
  import Grid from '../grid/grid'
  import GridMenuA from '../grid-menu/grid-menu-a.vue'
  import util from '@/libs/util'
  export default {
    name: 'show-delete-record',
    components: {
      Grid,
      GridMenuA
    },
    data() {
      return {
        visible: false,
        detailData: null,
        namespace: this.$route.query.namespace,
        isLoadConfig: true
      }
    },
    beforeRouteUpdate(to, from, next) {
      this.isLoadConfig = false
      this.$nextTick(() => (this.isLoadConfig = true))
      next()
    },
    computed: {
      gridConfigUrl: function () {
        return this.$route.meta.url
      }
    },
    methods: {
      showDetail: function (row) {
        let data = JSON.parse(row.statusData).data
        delete data['id']
        for (let key in data) {
          if (data[key] === null || data[key] === '') {
            delete data[key]
          }
        }
        this.detailData = data
        this.visible = true
      },
      handleDialogClose: function () {
        this.visible = false
      },
      back: function () {
        util.routerBack(this)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/record/show-delete-record.vue